/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { AirwallexMigrationStatus } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class AwxMigrationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags awx-migration-controller
   * @name GetAirwallexUkMigrationStatus
   * @request GET:/api/v1/airwallex-uk-migration
   */
  getAirwallexUkMigrationStatus = (params: RequestParams = {}) =>
    this.http.request<AirwallexMigrationStatus, any>({
      path: `/v1/airwallex-uk-migration`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAirwallexUkMigrationStatusPath = '/v1/airwallex-uk-migration'
  static getAirwallexUkMigrationStatusMethod = 'GET'
}
